<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          page-title="Administración"
          directory="Licencias"
          :icon="'trello'"
        />
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <button
            type="button"
            class="btn btn-primary btn-with-shadow"
            @click="
              () => {
                $hub.$emit('reload-' + tableId);
              }
            "
          >
            <i data-feather="refresh-ccw" class="pr-2" /> Refrescar
          </button>
          <!-- <a
            class="btn btn-primary btn-with-shadow"
            :href="`/accreditations/renew-payments`"
            ><app-icon name="plus" /> Añadir
          </a> -->
          <button
            type="button"
            class="btn btn-primary btn-with-shadow"
            data-toggle="modal"
            @click="openAddEditModal"
          >
          <i data-feather="plus" class="pr-2" />
            {{ $t("Añadir") }}
          </button>
        </div>
      </div>
    </div>
    <app-table :id="tableId" :options="options" @action="getListAction"/>
    <renew-payment-modal 
      v-if="isAddEditModalActive"
      @close-modal="closeAddEditModal"
      :table-id="tableId"
      :accreditation-area-list="accreditationAreaList"
      :accreditation-activity-list="accreditationActivityList"
    />
    <app-confirmation-modal
      v-if="deleteConfirmationModalActive"
      :preloader="deleteLoader"
      modal-id="application-delete"
      @confirmed="confirmed"
      @cancelled="cancelled"
      title="Confirmación"
      message="¿Desea eliminar este registro?"
    />
  </div>

</template>

<script>
import CoreLibrary from "@/core/helpers/CoreLibrary.js";
import * as actions from "../../../apiUrl";
import { TableHelpers } from "./TableHelpers";

export default {
extends: CoreLibrary,
mixins: [TableHelpers],
data() {
    return {
      tableId: "license-management-oec-table",
      rowData: {},
      selectedUrl: "",
      deleteLoader: false,
      options: {
        name: "license-management-oec-table",
        url: `/accreditations/oec/manage-licenses/indexManagement`,
        showHeader: true,
        columns: [],
        actions: [
          {
            title: this.$t("Subir Pago"),
            icon: "edit",
            type: "none",
          },
          {
            title: this.$t("Ver Pago"),
            icon: "file-text",
            type: "none",
          },
          {
            title: this.$t("delete"),
            icon: "trash",
            type: "none",
          },
        ],
        filters: [
          {
              title: "Actividad",
              type: "checkbox",
              key: "accreditation_activity",
              option: [],
          },
          {
            title: this.$t("Filtrar por fechas"),
            type: "range-picker",
            key: "date",
            option: ["today", "thisMonth", "last7Days"],
          },
        ],
        showFilter: true,
        showSearch: false,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "default",
      },
      isAddEditModalActive: false,
      deleteConfirmationModalActive: false,
    };
  },
  computed: {
    accreditationAreaList() {
      return [
        { id: "", value: "Selecciona una opción" },
        ...this.$store.state.accreditation.accAppOptions.accreditationAreas,
      ];
    },
    accreditationActivityList() {
      return [
        { id: "", value: "Selecciona una opción" },
        ...this.$store.state.accreditation.accAppOptions
          .accreditationActivities,
      ];
    },
  },
  watch: {
    "$store.state.accreditation.accAppOptions": function () {
      this.searchAndSelectFilterOptions();
    },
  },
  created() {
    this.options.columns = [...this.tableColumns, this.actionObj];
    this.data();
  },
  methods: {
    data() {
      this.$store.dispatch("getAccAppOptions");
    },
    searchAndSelectFilterOptions() {
      
      const area = this.options.filters.find(
          (element) => element.key === "accreditation_activity"
      );
      area.option =
          this.$store.state.accreditation.accAppOptions.accreditationActivities;

    },
    getListAction(rowData, actionObj, active) {
      this.rowData = rowData;
      if (actionObj.title == "Subir Pago") {
        if(!this.rowData.acc_app_id && !this.rowData.is_process){
          console.log(this.rowData.id);
          this.selectedUrl = `/accreditations/renew-payments/renewal/${rowData.id}`;
          window.location = this.selectedUrl;
        }
      }
      if (actionObj.title == "Ver Pago") {
        let url = rowData.license_payment_file;
        if (url) {
          const w = window.open(url.path, "_blank");
          w.focus();
        } else {
          this.$toastr.e(this.$t("No se pudo encontar el archivo"));
        }
      }
      if (actionObj.title == this.$t("delete")) {
        if(!this.rowData.acc_app_id) {
          if(!this.rowData.is_process && this.rowData.is_approved != 1) {
            this.openDeleteModal();
          } else {
            this.$toastr.e(this.$t("El pago de licencia se encuentra en proceso de aprobación o ya esta aprobado"));
          }
            
        }
      }
    },
    openAddEditModal() {
      this.isAddEditModalActive = true;
    },
    closeAddEditModal() {
      $("#renew-modal-start").modal("hide");
      this.isAddEditModalActive = false;
    },
    openDeleteModal() {
      this.deleteConfirmationModalActive = true;
    },
    cancelled() {
      this.deleteConfirmationModalActive = false;
      this.reSetData();
    },

    reSetData() {
      this.rowData = {};
      this.selectedUrl = "";
    },

    confirmed() {
      let url = `/accreditations/renew-payments/${this.rowData.id}`;
      this.deleteLoader = true;
      this.axiosDelete(url)
        .then((response) => {
          this.deleteLoader = false;
          $("#application-delete").modal("hide");
          this.cancelled();
          // this.$toastr.s(response.data.message);
          this.$toastr.s(this.$t("deleted_success"));
        })
        .catch(({ error }) => {
          //trigger after error
        })
        .finally(() => {
          this.$hub.$emit("reload-" + this.tableId);
        });
    },
  },
}
</script>

<style>

</style>